import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import logo from '../assets/airforschen-logo.svg';

const Header: React.FC = () => {
  const { isAuthenticated, logout } = useAuth();

  return (
    <header
      style={{
        background: 'linear-gradient(to right, #0F4FD1, #31BEEF)',
        height: '100px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingLeft: '40px',
        paddingRight: '40px',
      }}
    >
      <img
        src={logo}
        alt="AIRforschen Logo"
        style={{
          height: 'calc(100px / 3)',
          objectFit: 'contain',
        }}
      />
      {isAuthenticated && (
        <button
          onClick={logout}
          className="btn btn-light"
          style={{
            fontWeight: 700,
          }}
        >
          Abmelden
        </button>
      )}
    </header>
  );
};

export default Header;
